export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const ADD_CONTACT = 'ADD_CONTACT';
export const GET_CONTACT = 'GET_CONTACT';
export const GET_CONTACTS = 'GET_CONTACTS';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const CONTACT_FAIL = 'CONTACT_FAIL';
export const ADD_ACTION = 'ADD_ACTION';
export const GET_ACTION = 'GET_ACTION';
export const GET_ACTIONS = 'GET_ACTIONS';
export const DELETE_ACTION = 'DELETE_ACTION';
export const ADD_DEAL = 'ADD_DEAL';
export const GET_DEAL = 'GET_DEAL';
export const GET_DEALS = 'GET_DEALS';
export const ADD_ACTIVITY = 'ADD_ACTIVITY';
export const GET_ACTIVITY = 'GET_ACTIVITY';
export const GET_ACTIVITIES = 'GET_ACTIVITIES';
export const DELETE_DEAL = 'DELETE_DEAL';



// WEBPACK FOOTER //
// ./src/actions/types.js